<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/stores/app'
import { useResourcesStore } from '@/stores/resources'
import { useTr } from '@/composables/useTr'
import { reportTemplates } from '@/data/reports'

const app = useAppStore()
const res = useResourcesStore()
const { tr } = useTr()

const reportsData = computed(() => res.viewReports)

const byState = (s: string) => reportsData.value.filter((r) => r.state === s).length
</script>

<template>
  <aside class="reports-sub-nav">
    <div class="ssn-header">{{ tr('报告状态', 'Report Status') }}</div>
    <div class="ssn-item" :class="{ active: app.reportsFilter === 'all' }" @click="app.reportsFilter = 'all'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /></svg></span>
      <span style="flex:1;">{{ tr('全部', 'All') }}</span>
      <span class="badge num">{{ reportsData.length }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.reportsFilter === 'draft' }" @click="app.reportsFilter = 'draft'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg></span>
      <span style="flex:1;">{{ tr('草稿', 'Draft') }}</span>
      <span class="badge num">{{ byState('draft') }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.reportsFilter === 'submitted' }" @click="app.reportsFilter = 'submitted'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-info); margin-right:2px;" />
      <span style="flex:1;">{{ tr('已提交', 'Submitted') }}</span>
      <span class="badge num">{{ byState('submitted') }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.reportsFilter === 'accepted' }" @click="app.reportsFilter = 'accepted'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-low); margin-right:2px;" />
      <span style="flex:1;">{{ tr('已接受', 'Accepted') }}</span>
      <span class="badge num">{{ byState('accepted') }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.reportsFilter === 'rejected' }" @click="app.reportsFilter = 'rejected'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-crit); margin-right:2px;" />
      <span style="flex:1;">{{ tr('被驳回', 'Rejected') }}</span>
      <span class="badge num">{{ byState('rejected') }}</span>
    </div>
    <div class="ssn-header" style="padding-top:14px;">{{ tr('模板 & 导出', 'Templates & Export') }}</div>
    <div class="ssn-item" :class="{ active: app.reportsFilter === 'templates' }" @click="app.reportsFilter = 'templates'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /></svg></span>
      <span style="flex:1;">{{ tr('报告模板', 'Report Templates') }}</span>
      <span class="badge num">{{ reportTemplates.length }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.reportsFilter === 'export' }" @click="app.reportsFilter = 'export'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" /></svg></span>
      <span style="flex:1;">{{ tr('导出历史', 'Export History') }}</span>
      <span class="badge num">12</span>
    </div>
    <div class="ssn-header" style="padding-top:14px;">{{ tr('订阅状态', 'Subscription') }}</div>
    <div class="ssn-item" style="background:var(--panel-soft);" @click="app.proModal = true">
      <span class="ssn-icon"><svg fill="none" stroke="var(--pro-lock)" stroke-width="1.8" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0110 0v4" /></svg></span>
      <span style="flex:1;">{{ tr('AI 草稿 (Pro)', 'AI Draft (Pro)') }}</span>
      <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
    </div>
  </aside>
</template>
